import { useEffect, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  query,
  where,
  orderBy,
  getDocs,
  updateDoc,
  doc,
} from "firebase/firestore";
import { motion, AnimatePresence } from "framer-motion";

function NotificationsPage() {
  const [notifications, setNotifications] = useState([]);
  const [error, setError] = useState("");
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const q = query(
          collection(db, "notifications"),
          where("userId", "==", userId),
          orderBy("timestamp", "desc")
        );
        const snapshot = await getDocs(q);
        const items = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
        setNotifications(items);

        // Bildirimleri okundu olarak işaretle
        for (const docSnap of snapshot.docs) {
          await updateDoc(doc(db, "notifications", docSnap.id), { read: true });
        }
      } catch (err) {
        setError(`Bildirimler yüklenirken hata oluştu: ${err.message}`);
      }
    };

    if (userId) fetchNotifications();
  }, [userId]);

  const notificationText = (notification) => {
    switch (notification.type) {
      case "like":
        return "postunu beğendi.";
      case "comment":
        return "postuna yorum yaptı.";
      case "mention":
        return "seni bir postta etiketledi.";
      case "congratulation":
        return "seni tebrik etti! 🎉";
      default:
        return "bir etkinlikte bulundu.";
    }
  };

  return (
    <motion.div
      style={containerStyle}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <motion.h2
        style={headerStyle}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1, duration: 0.5 }}
      >
        🔔 Bildirimler
      </motion.h2>
      {notifications.length === 0 ? (
        <motion.p
          style={emptyMessageStyle}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          Henüz bildirimin yok.
        </motion.p>
      ) : (
        <AnimatePresence>
          {notifications.map((n, index) => (
            <motion.div
              key={n.id}
              style={cardStyle}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ delay: index * 0.1, duration: 0.3 }}
            >
              <p style={messageTextStyle}>
                <strong>{n.fromUsername}</strong> {notificationText(n)}
              </p>
              <p style={timestampStyle}>
                {n.timestamp?.toDate().toLocaleString()}
              </p>
            </motion.div>
          ))}
        </AnimatePresence>
      )}

      <AnimatePresence>
        {error && (
          <motion.p
            style={errorTextStyle}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.3 }}
          >
            {error}
          </motion.p>
        )}
      </AnimatePresence>
    </motion.div>
  );
}

const containerStyle = {
  background: "linear-gradient(135deg, #0f2027, #203a43, #2c5364)",
  minHeight: "100vh",
  padding: "40px",
  fontFamily: "'Inter', sans-serif",
  color: "#f0f0f0",
};

const headerStyle = {
  fontSize: "32px",
  textAlign: "center",
  marginBottom: "30px",
  color: "#00ffcc",
  textShadow: "0 0 10px rgba(0, 230, 118, 0.3)",
};

const emptyMessageStyle = {
  textAlign: "center",
  fontSize: "18px",
  color: "#b0bec5",
};

const cardStyle = {
  background: "rgba(255, 255, 255, 0.05)",
  borderRadius: "16px",
  padding: "20px",
  marginBottom: "20px",
  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.5)",
  border: "1px solid rgba(0, 230, 118, 0.2)",
};

const messageTextStyle = {
  fontSize: "18px",
  marginBottom: "8px",
  color: "#f0f0f0",
};

const timestampStyle = {
  fontSize: "14px",
  color: "#b0bec5",
  textAlign: "right",
};

const errorTextStyle = {
  marginTop: "20px",
  textAlign: "center",
  fontSize: "14px",
  color: "#f44336",
};

export default NotificationsPage;